<template>
  <div class="drag-task">
    <div class="actions-wrapper">
      <button class="btn btn-light" v-b-tooltip.hover.top title="Copy" @click="$emit('setCopyTask', item)">
        <i class="fa fa-clone"></i>
      </button>
      <button class="btn btn-light" v-b-tooltip.hover.top title="Edit" @click="$emit('setOpenTask', item)">
        <i class="fa fa-edit"></i>
      </button>
      <button class="btn btn-light" v-b-tooltip.hover.top title="Delete" @click="$emit('setDeleteTask', item)">
        <i class="fa fa-trash-o"></i>
      </button>
    </div>

    <div class="drag-card-body">
      <div class="row mb-4">
        <div class="col-md-10">
          <h6 class="f-w-600">
            <span v-if="item.isRequired" class="task-badge">Required</span>
            <span>{{ item.title }}</span>
            <a href="#" @click.prevent="$emit('openTaskDetail', item)">More Info</a>
          </h6>
          <p class="mr-3 white-space-pre-line">{{ trimMyString(item.description, 200) }}</p>
        </div>
        <div class="col-md-2">
          <div class="d-flex justify-content-end">
            <button type="button" class="btn btn-pill btn-light btn-collapseicon"
              :class="{ 'collapsed': isTaskResourcesOpen }"
              @click="toggleTaskResources()">
              Resources&nbsp;
              <i class="fa fa-angle-right"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="move-btn handl" v-handle>
        <img src="../assets/images/move.svg" alt="">
      </div>
      <div v-if="isTaskResourcesOpen" class="card mt-5" style="background-color: #F6F7FB">
        <div class="card-body">
          <div class="d-flex justify-content-between mb-4">
            <div>
              <h6 class="f-w-600">Resources</h6>
            </div>
            <div>
              <button class="btn btn-pill btn-secondary btn-sm" @click="openModalTaskResource()">Add Resource</button>
            </div>
          </div>
          <div class="card mb-0">
            <div class="card-body">
              <table class="table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Resource</th>
                    <th>Date</th>
                    <th class="text-center">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="taskResources.length === 0">
                    <td colspan="4" class="text-center">No Resources Found</td>
                  </tr>
                  <tr v-else v-for="(resource, i) in taskResources" :key="i">
                    <td>{{ resource.name }}</td>
                    <td v-if="resource.resourceType == 'link'">
                      <a v-bind:href="resource.url" title="Open Link" target="_blank">
                        <img :src="getIconByResourceType(resource.resourceType)" alt="open link" />
                      </a>
                    </td>
                    <td v-else>
                      <a v-bind:href="resource.fileUrl" title="Download File" download>
                        <img :src="getIconByResourceType(resource.resourceType)" alt="download file" />
                      </a>
                    </td>
                    <td>{{ resource.createdDate }}</td>
                    <td>
                      <div class="d-flex justify-content-center">
                        <button class="btn btn-light px-2 mr-3" v-b-tooltip.hover.top title="Edit Resource"
                          @click="openModalTaskResource(resource)">
                          <i class="fa fa-edit m-0"></i>
                        </button>
                        <button class="btn btn-light px-2" v-b-tooltip.hover.top title="Delete Resource"
                          @click="deleteTaskResource(resource)">
                          <i class="fa fa-trash-o m-0"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal ref="task-resources" v-bind:title="taskResourceIsNew ? 'Create Resource' : 'Edit Resource'" hide-footer no-close-on-backdrop>
      <form @submit.prevent="handleSubmit" class="d-block p-2">
        <div v-if="taskResourceIsNew" class="mb-4">
          <label for="task-resources-name">Type</label>
          <b-form-select class="form-control form-control-primary btn-square custom-select" v-model="taskResource.type"
            :options="taskResourceTypes" @change="changeTaskResourceType"
            :class="{ 'is-invalid': submitted && $v.taskResource.type.$error }">
            <template #first>
              <b-form-select-option :value="null" disabled>-- Select a Type --</b-form-select-option>
            </template>
          </b-form-select>
          <div v-if="submitted && !$v.taskResource.type.required" class="invalid-feedback">Resource Type is required</div>
        </div>
        <div class="mb-4">
          <label for="task-resources-name">Name</label>
          <input type="text" id="task-resources-name" name="name" class="form-control" v-model="taskResource.name"
          :class="{ 'is-invalid': submitted && $v.taskResource.name.$error }" />
          <div v-if="submitted && !$v.taskResource.name.required" class="invalid-feedback">Resource Name is required</div>
        </div>
        <div v-if="taskResourceIsNew && taskResource.type" class="mt-4">
          <div v-if="taskResource.type == 'link'">
            <label for="task-resources-name">URL</label>
            <input type="url" id="task-resources-url" name="name" class="form-control" v-model="taskResource.url"
              :class="{ 'is-invalid': submitted && $v.taskResource.url.$error }" />
            <div v-if="submitted && !$v.taskResource.url.required" class="invalid-feedback">URL is required</div>
            <div v-if="submitted && !$v.taskResource.url.maxLength" class="invalid-feedback">URL must have max 1000 characters</div>
          </div>
          <div v-else>
            <div class="d-flex justify-content-center">
              <label v-if="taskResourceFile" for="task-resources-file" class="uploader-file">
                <img :src="taskResourceFile" width="170" height="170" alt="" />
              </label>
              <div v-else>
                <label for="task-resources-file" class="uploader-dashed d-flex justify-content-center align-items-center">
                  Select a file
                </label>
              </div>
              <input type="file" id="task-resources-file" name="resource" ref="taskResourceFile"
                @change="selectTaskResourceFile" hidden
                accept=".doc,.docx,application/msword,xls,xlsx,csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-powerpoint,application/pdf,image/jpeg,image/png" />
            </div>
          </div>
        </div>
        <div class="mt-5 mb-3">
          <button class="btn btn-primary" type="submit" :disabled="loadingSubmit">Save</button>
          <a class="btn btn-light ml-2" href="#" @click.prevent="closeModalTaskResources()">Cancel</a>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import { ElementMixin, HandleDirective } from 'vue-slicksort';
import { required, requiredIf, maxLength } from "vuelidate/lib/validators";
import moment from 'moment';

export default {
  name: "SortableItem",
  data() {
    return {
      taskResources: [],
      taskResource: {
        id: 0,
        type: null,
        name: '',
        url: null
      },
      taskResourceTypes: [
        { value: "file", text: 'File' },
        { value: "link", text: 'Link' },
      ],
      taskResourceFile: null,
      taskResourceIsNew: true,
      isTaskResourcesOpen: false,
      loadingSubmit: false,
      submitted: false
    }
  },
  validations: {
    taskResource: {
      type: { required },
      name: { required },
      url: {
        required: requiredIf(function() {
          return this.taskResource.type == 'link';
        }),
        maxLength: maxLength(1000)
      }
    }
  },
  mixins: [ElementMixin],
  directives: { handle: HandleDirective },
  props: ['item', 'dayTimeSection_options', 'daysOfWeekOptions', 'showHandle'],
  watch:{
    'taskResource.url': function (val){
      if (this.loadingSubmit && val.length <= 1000)
      this.loadingSubmit = false
    }
  },
  methods: {
    checkDayName(item) {
      let text = "";
      this.dayTimeSection_options.forEach((val) => {
        if (
            val.value.toLowerCase() === item.toLowerCase() ||
            val.text.toLowerCase() === item.toLowerCase()
        ) {
          text = val.text
        }
      });

      return text;
    },
    trimMyString(string, maxLength, isSpace, start = 0) {
      if (!string) return ''
      if (string.length > maxLength) {
        let trimmedString = string.substr(start, maxLength);
        return (
            trimmedString.substr(
                start,
                Math.min(trimmedString.length, isSpace ? trimmedString.lastIndexOf(' ') : trimmedString.lastIndexOf(''))
            ) + ' ...'
        )
      }
      return string
    },
    toggleTaskResources() {
      if (this.isTaskResourcesOpen) {
        this.isTaskResourcesOpen = false;
        return;
      }

      this.isTaskResourcesOpen = true;
      this.getTaskResources();
    },
    async getTaskResources() {
      this.taskResources = [];

      this.$store.dispatch('getTaskResources', this.item.id)
      .then(async(val) => {
        if (val.data.result) {
          val.data.result.forEach((record) => {
            this.taskResources.push({
              id: record.id,
              resourceType: record.resourceType,
              name: record.name,
              fileUrl: record.fileUrl,
              url: record.url,
              createdDate: moment(record.createdDate).format('MMM D, YYYY')
            });
          });
        }
      });
    },
    openModalTaskResource(resource = null) {
      this.taskResourceIsNew = true;

      this.taskResource = {
        id: 0,
        type: null,
        name: '',
        url: null
      };

      if (resource) {
        this.taskResourceIsNew = false;

        this.taskResource = {
          id: resource.id,
          name: resource.name
        };
      }

      this.$refs['task-resources'].show();
    },
    closeModalTaskResources() {
      this.$refs['task-resources'].hide();
    },
    changeTaskResourceType() {
        this.taskResourceFile = null;
        this.taskResource.url = null;
    },
    selectTaskResourceFile() {
      if (this.$refs.taskResourceFile.files.length == 0) {
        return;
      }

      var images = require.context('./../assets/images/task-resources/', false, /\.png$/);
      this.taskResourceFile = images(`./icon-file.png`);
    },
    getIconByResourceType(type) {
      let image = 'icon-file.png';

      if (type == 'link') {
        image = 'icon-link.png';
      }

      var images = require.context('./../assets/images/task-resources/', false, /\.png$/);
      return images(`./${image}`);
    },
    handleSubmit() {
      if (this.taskResourceIsNew) {
        this.handleSubmitCreate();
      }
      else {
        this.handleSubmitUpdate();
      }
    },
    async handleSubmitCreate() {
      this.loadingSubmit = true;
      this.submitted = true;
      let file = null;

      this.$v.taskResource.$touch();
      if (this.$v.taskResource.$invalid) {
        return;
      }

      if (this.$refs.taskResourceFile && this.$refs.taskResourceFile.files.length > 0) {
        file = this.$refs.taskResourceFile.files[0];
      }

      let payload = new FormData();
      payload.append('TaskId', this.item.id);
      payload.append('ResourceType', this.taskResource.type);
      payload.append('Name', this.taskResource.name);
      payload.append('Url', this.taskResource.url);
      payload.append('File', file);

      this.$store.dispatch('createTaskResource', payload)
      .then(async(val) => {
        if (val.data.statusCode && val.data.statusCode === 200) {
          this.toaster('success', val.data.message);
          this.closeModalTaskResources();
          this.getTaskResources();
        }
        else {
          this.toaster('error', val.data.result);
        }

        this.loadingSubmit = false;
        this.submitted = false;
      })
      .catch(async(val) => {
        const message = this.formatExceptionMessage(val);
        this.toaster('error', message);

        this.loadingSubmit = false;
        this.submitted = false;
      });
    },
    async handleSubmitUpdate() {
      this.loadingSubmit = true;
      this.submitted = true;

      const payload = {
        id: this.taskResource.id,
        name: this.taskResource.name
      };

      this.$store.dispatch('updateTaskResource', payload)
      .then(async(val) => {
        this.toaster('success', val.data.message);
        this.closeModalTaskResources();
        this.getTaskResources();

        this.loadingSubmit = false;
      })
      .catch(async(val) => {
        const message = this.formatExceptionMessage(val);
        this.toaster('error', message);

        this.loadingSubmit = false;
      });
    },
    deleteTaskResource(resource) {
      this.$swal({
        text: `Are you sure you want to delete the resource "${resource.name}"?`,
        showCancelButton: true,
        confirmButtonText: 'Yes',
        confirmButtonColor: '#4466f2',
        cancelButtonText: 'Cancel',
        cancelButtonColor: '#efefef',
        reverseButtons: true
      }).then((val) => {
        if (val.value) {
          this.handleDelete(resource);
        }
      });
    },
    async handleDelete(resource) {
      this.$store.dispatch('deleteTaskResources', resource.id)
      .then(async(val) => {
        if (val.data.statusCode && val.data.statusCode === 200) {
          this.toaster('success', val.data.message);
          this.getTaskResources();
        }
        else {
          this.toaster('error', val.data.result);
        }
      })
      .catch(async(val) => {
        const message = this.formatExceptionMessage(val);
        this.toaster('error', message);
      });
    },
    formatExceptionMessage(val) {
      const resp = val.response.data;
      return resp.responseException && resp.responseException.exceptionMessage ? resp.responseException.exceptionMessage : 'Please try again';
    },
    toaster(type, message) {
      this.$toasted.show(message, {
        theme: 'bubble',
        position: 'top-right',
        type: type,
        duration: 3000
      });
    }
  }
}
</script>

<style scoped lang="scss">
  .drag-task {
    letter-spacing: 1px !important;
    margin-bottom: 30px;
    border: 0;
    border-radius: 8px;
    box-shadow: 1px 5px 24px 0 #4466f20d;
    display: flex;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background-color: #fff;
    background-clip: border-box;
    position: relative;
    overflow: hidden;

    .drag-card-body {
      padding: 20px;

      h6 {
        display: flex;
        align-items: center;
        white-space: pre-wrap;
        flex-wrap: wrap;

        a:hover {
          text-decoration: underline;
        }

        span {
          margin-right: 5px;
          margin-bottom: 5px;
        }
      }
    }

    .actions-wrapper {
      position: absolute;
      display: flex;
      bottom: 0;
      right: 36px;

      button {
        width: 36px;
        padding: 10px 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 0;

        i {
          margin: 0;
        }
      }
    }

    .move-btn {
      position: absolute;
      user-select: none;
      top: calc(100% - 36px);
      right: 0;
      overflow: hidden;
      opacity: 0;
      transition: 0.3s;
      width: 36px;
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: move;
      background-color: #8ba2c4;

      img {
        width: 18px;
        height: 18px;
        margin: 0;
      }
    }

    &:hover .move-btn {
      overflow: visible;
      opacity: 1;
    }

    .move-btn {
      position: absolute;
      top: calc(100% - 36px);
      right: 0;
      overflow: hidden;
      opacity: 0;
      transition: 0.3s;
      width: 36px;
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: move;
      background-color: #8ba2c4;

      img {
        width: 18px;
        height: 18px;
        margin: 0;
      }
    }

    .task-content-info-inModal {
      display: flex;
      flex-direction: column;
      width: 50%;

      &:first-child {
        padding-right: 10px;
      }

      &:last-child {
        padding-left: 10px;
      }
    }
  }
  .task-badge {
    background-color: #28A745;
    color: #fff;
    padding: 4px 7px;
    border-radius: 3px;
    font-size: .8rem;
    font-weight: normal;
  }
  .uploader-dashed {
    width: 160px;
    height: 160px;
    cursor: pointer;
    border: #bbbbbb dashed 5px;
    color: #afafaf;

    &:hover {
      border: #cccccc dashed 5px;
    }
  }
  .uploader-file {
    width: 160px;
    height: 160px;
    display: inline-block;
    cursor: pointer;

    img {
      &:hover {
        transform: scale(0.98);
      }
    }
  }
  .custom-select {
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
  }
  .btn-collapseicon {
    padding: 0.375rem 14px;
    color: #2a3142;
    &:hover {
      background-color: #4466f2 !important;
      border-color: #4466f2 !important;
      color: #fff !important;
    }

    i {
      margin: 0 auto;
      transition: 0.5s;
      transform: rotate(0deg);
    }

    &.collapsed {
      background-color: #4466f2 !important;
      border-color: #2a3142;
      color: #fff !important;
      i {
        transform: rotate(90deg);
      }
    }
  }

  @media (max-width: 768px) {
    .drag-task .move-btn {
      visibility: visible;
      opacity: 1;
    }
  }
</style>
